import { render, staticRenderFns } from "./ActivityTab.vue?vue&type=template&id=5ab9b7c4&scoped=true&"
import script from "./ActivityTab.vue?vue&type=script&lang=js&"
export * from "./ActivityTab.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTab.vue?vue&type=style&index=0&id=5ab9b7c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab9b7c4",
  null
  
)

export default component.exports